const LEARNING_ITEM_TYPES = Object.freeze({
  COURSE: "SIMPLE",
  SESSION: "SESSION",
});

const LEARNING_ITEM_CONFIGS = Object.freeze({
  [LEARNING_ITEM_TYPES.SESSION]: {
    heroEyebrow: "5-Week Add-On Program",
    heroSubtitle:
      "Master the skills to deploy, operate, and scale LLM-powered applications in production. Bridge DevOps best practices with AI/ML workflows and tools.",
    defaultCtaTitle: "Ready to advance your career with LLMOps?",
    defaultCtaDescription:
      "Join professionals transforming the future of AI with DevOps.",
    purchaseTitle: "Choose your purchase option",
    openActionLabel: "Enroll Now",
    closedActionLabel: "Enrollment Closed",
    previewLabel: "Preview course",
    usesPaymentPlans: true,
  },
  [LEARNING_ITEM_TYPES.COURSE]: {
    heroEyebrow: "Online Course",
    heroSubtitle:
      "Build practical skills with structured lessons, hands-on material, and lifetime access to course resources.",
    defaultCtaTitle: "Ready to start learning?",
    defaultCtaDescription:
      "Get access to the course and progress through the material at your own pace.",
    purchaseTitle: "Course price",
    openActionLabel: "Start Now",
    closedActionLabel: "Course Closed",
    previewLabel: "Preview course",
    usesPaymentPlans: false,
  },
});

const getLearningItemType = (type) =>
  type === LEARNING_ITEM_TYPES.COURSE
    ? LEARNING_ITEM_TYPES.COURSE
    : LEARNING_ITEM_TYPES.SESSION;

const getLearningItemConfig = (type) =>
  LEARNING_ITEM_CONFIGS[getLearningItemType(type)];

export {
  LEARNING_ITEM_TYPES,
  getLearningItemConfig,
  getLearningItemType,
};
